<template>
  <div>
    <el-input
      type="textarea"
      autosize
      placeholder="请输入备忘"
      v-model="content"
      @change="(value)=>$emit('input',value)">
    </el-input>
    <el-button type="primary"
               @click="onUpdateOrderMemo"
               size="mini">更新备忘
    </el-button>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    orderid: {
      type: Number,
      value: 0,
    },
    memo: {
      type: String,
      value: '',
    },
  },
  data () {
    return {
      content: this.memo,
    }
  },
  watch: {
    memo () {
      if (this.memo !== this.content) {
        this.content = this.memo
      }
    },
  },

  methods: {
    onUpdateOrderMemo () {
      let detail = {
        memo: this.content,
        orderid: this.orderid,
      }

      request.common('updateOrderMemo', detail).then((res) => {
        this.$message('更新备忘成功！')
      })
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/views/order/components/OrderMemoUpdate.vue